/*
  fetch polyfill (needed for older versions of Internet Explorer)
*/
import "whatwg-fetch";

import Vue from "vue";
window.$useCache = Vue.prototype.$useCache = {
  rawitems: true,
  menu: false,
  sitemap: true,
  pageByCid: true,
  pageByPath: true,
  pageUi: true,
  productAttr: true,
  productRelated: true,
  catalogProducts: true,
  catalogFilters: true,
  research: false
};
Vue.config.productionTip = false;

// Global Vue scoped variables
Vue.prototype.$imageFolder = "https://www.mis-implants.com/upload";
Vue.prototype.$fileFolder = "https://www.mis-implants.com/upload/";
Vue.prototype.$defaultLang = "en";
Vue.prototype.$defaultCountrycode = "";

import { sync } from "vuex-router-sync";
import App from "./App.vue";
import router from "./router";
import store from "./store";

sync(store, router);

import VueHead from "vue-head";
Vue.use(VueHead);

// import "./registerServiceWorker";
import "@/styl/style.styl";

// Global Mixins
import { localize } from "./mixins/localize.js";
Vue.mixin(localize);

// Global Components
import "@/components/globalComponents";

//////////////////////////////////////////////////////// PLUGINS >>
// https://github.com/Orlandster/vue-page-transition
// import VuePageTransition from "vue-page-transition";
// Vue.use(VuePageTransition);
// https://github.com/dreambo8563/vue-device-detector
import device from "vue-device-detector";
Vue.use(device);
// // https://github.com/shhdgit/vue-easy-slider
// import EasySlider from 'vue-easy-slider'
// Vue.use(EasySlider)
import VuePaginate from "vue-paginate";
Vue.use(VuePaginate);

import VueScrollReveal from "vue-scroll-reveal";
// Using ScrollReveal's default configuration
Vue.use(VueScrollReveal);

import VueParallaxJs from "vue-parallax-js";
Vue.use(VueParallaxJs);

import AsyncComputed from "vue-async-computed";
Vue.use(AsyncComputed);
// /////////////////////////////////////////////////////// PLUGINS

// Use v-calendar & v-date-picker components
// if (!isIE) {
// import VCalendar from "v-calendar";
// Vue.use(VCalendar);

// }

import SocialSharing from "vue-social-sharing";
Vue.use(SocialSharing);

import smoothscroll from "smoothscroll-polyfill";

// kick off the polyfill!
smoothscroll.polyfill();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

Array.prototype.moveto = function(from, to) {
  this.splice(to < 0 ? this.length + to : to, 0, this.splice(from, 1)[0]);
  return this;
};
